import React, { useContext } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { THEME_UPDATE_MESSAGE, ThemeNo } from "../../../../constant";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { TostMessage } from "../../../utils";
import ProductBuyContext from "../../../context/ProductBuyContext/ProductBuyContext";
import { ProductBuyStyleOne } from "./AllStyleOfProductBuy";
import { putUpdateProductBuy } from "../apis/ProductBuyApi/ProductBuyApi";
import ProductBuyThemeOne from "./ProductBuyThemeOne";
import ProductBuyTheme1 from "../ScreenShorts/ProductBuy/ProductBuyTheme1.png";
import ThemeImageShow from "../../../common/ThemeImageShow";

const SettingStyle = (props) => {
  const {
    isEdit,
    setSettingFormData,
    id,
    theme,
    setTheme,
    imgShow,
    setImgShow,
    settingFormData,
  } = useContext(ProductBuyContext);
  const {
    imageUpload,
    handleSubmitSetting,
    handleSettingStyle,
    handleSubmitRemoveCssSetting,
  } = props;
  const { setLoaderShow } = useContext(LoaderContext);

  const handleTheme = async (e) => {
    setLoaderShow(true);
    const { value } = e.target;
    setTheme(value);
    try {
      let formData = {
        theme: value,
        sliderId: id,
      };
      const { data } = await putUpdateProductBuy(formData);
      if (data.status === 200) {
        await handleSettingStyle("style", true);
        TostMessage({
          message: { message: THEME_UPDATE_MESSAGE },
          type: "success",
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    } finally {
      setLoaderShow(false);
    }
  };

  const resetHandler = () => {
    let setStyle;
    if (theme === ThemeNo.ThemeOne) {
      setStyle = ProductBuyStyleOne;
    } else {
      setStyle = ProductBuyStyleOne;
    }
    setSettingFormData({ ...setStyle });
  };
  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: ProductBuyTheme1,
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{isEdit ? "Edit" : "Add New"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  {/* <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button> */}
                  <Button
                    onClick={() => handleSubmitRemoveCssSetting(false, false)}
                  >
                    Remove Old Css
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(false, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              <Row>
                <Col>
                  <label htmlFor="">Theme</label>
                  <select
                    name="theme"
                    id="font-weight"
                    className="form-select"
                    value={theme}
                    onChange={(e) => handleTheme(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value={1}>Theme 1</option>
                  </select>
                </Col>
              </Row>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[1]}
                  handleClose={handleClose}
                />
              )}
              {true && (
                <ProductBuyThemeOne
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
              {/* {+theme === ThemeNo.ThemeOne && (
                <ProductBuyThemeOne
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )} */}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SettingStyle;
